export default {
  data () {
    return {
    }
  },

  computed: {
    account: {
      get () {
        return this.$store.state.account.token
      },
      set (newValue) {
        this.$store.commit('account/set', newValue)
      }
    },
    user: {
      get () {
        return this.$store.state.user.prof
      },
      set (payload) {
        this.$store.commit('user/set', payload)
      }
    },
    appVersion: {
      get () {
        return this.$store.state.appVersion.val
      },
      set (payload) {
        this.$store.commit('appVersion/set', payload)
      }
    },
    lic: {
      get () {
        return this.$store.state.lic.val
      }
    },
    twitterAuth: {
      get () {
        return this.$store.state.twitterAuth.val
      },
      set (payload) {
        this.$store.commit('twitterAuth/set', payload)
      }
    },
    isTwitter: {
      get () {
        return this.$store.state.isTwitter.flg
      },
      set (payload) {
        this.$store.commit('isTwitter/set', payload)
      }
    }
  },

  filters: {
    filterFileSize: function (size) {
      const KB = 1024
      const MB = KB * 1024
      const GB = MB * 1024

      if (size < KB) {
        return String(size + ' byte')
      } else if (size < MB) {
        return String(Math.floor(size / KB) + ' KB')
      } else if (size < GB) {
        return String(Math.floor(size / MB) + ' MB')
      }
      return size
    },
    displayTime: function (timeStamp) {
      let timestamp = timeStamp * 1000
      var date = new Date(timestamp)
      var diff = new Date().getTime() - date.getTime()
      var d = new Date(diff)

      if (d.getUTCFullYear() - 1970) {
        return d.getUTCFullYear() - 1970 + '年前'
      } else if (d.getUTCMonth()) {
        return d.getUTCMonth() + 'ヶ月前'
      } else if (d.getUTCDate() - 1) {
        return d.getUTCDate() - 1 + '日前'
      } else if (d.getUTCHours()) {
        return d.getUTCHours() + '時間前'
      } else if (d.getUTCMinutes()) {
        return d.getUTCMinutes() + '分前'
      } else {
        return d.getUTCSeconds() + '秒前'
      }
    },

    fullMilisec2ymdDay: function (timeStamp) {
      var d = new Date(timeStamp)
      var y = new Date(timeStamp)
      var year = y.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var today = new Date()
      var thisYear = today.getFullYear()

      if (year === thisYear) {
        return (month + '/' + day)
      } else {
        return (year + ' ' + month + '/' + day)
      }
    },

    unixTime2ymdDay: function (timeStamp) {
      var d = new Date(timeStamp * 1000)
      var y = new Date(timeStamp * 1000)
      var year = y.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var today = new Date()
      var thisYear = today.getFullYear()

      if (year === thisYear) {
        return (month + '/' + day)
      } else {
        return (year + ' ' + month + '/' + day)
      }
    },

    unixTime2ymdMin: function (timeStamp) {
      var d = new Date(timeStamp * 1000)
      var y = new Date(timeStamp * 1000)
      var year = y.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = ('0' + d.getHours()).slice(-2)
      var min = ('0' + d.getMinutes()).slice(-2)
      var today = new Date()
      var thisYear = today.getFullYear()
      // var sec = ('0' + d.getSeconds()).slice(-2)

      if (year === thisYear) {
        return (month + '月' + day + '日 ' + hour + '時' + min + '分')
      } else {
        return (year + '年' + month + '月' + day + '日 ' + hour + '時' + min + '分')
      }
    },

    groupIdToName: function (buf, sameSchoolGroups) {
      let names = []
      for (let i = 0; i < buf.length; i++) {
        for (let j = 0; j < sameSchoolGroups.length; j++) {
          if (buf[i].id === sameSchoolGroups[j].id) {
            names.push(sameSchoolGroups[j].name)
            names.push('/')
          }
        }
      }
      return names.join('')
    }
  },

  methods: {
    sortBubblyByTimeStamp: function (ary) {
      var tmp = ''
      for (let i = ary.length - 1; i > 0; i--) {
        for (let j = 0; j < i; j++) {
          if (ary[j].timeStamp > ary[j + 1].timeStamp) {
            tmp = ary[j]
            ary[j] = ary[j + 1]
            ary[j + 1] = tmp
          }
        }
      }
      return ary
    },

    sortDecendingByTimeStamp: function (ary) {
      var tmp = ''
      for (let i = ary.length - 1; i > 0; i--) {
        for (let j = 0; j < i; j++) {
          if (ary[j].timeStamp < ary[j + 1].timeStamp) {
            tmp = ary[j]
            ary[j] = ary[j + 1]
            ary[j + 1] = tmp
          }
        }
      }
      return ary
    },

    sortBubblyByName: function (ary) {
      var tmp = ''
      for (let i = ary.length - 1; i > 0; i--) {
        for (let j = 0; j < i; j++) {
          if (ary[j].name > ary[j + 1].name) {
            tmp = ary[j]
            ary[j] = ary[j + 1]
            ary[j + 1] = tmp
          }
        }
      }
      return ary
    },

    sortBubblyByGroupName: function (ary) {
      var tmp = ''
      for (let i = ary.length - 1; i > 0; i--) {
        for (let j = 0; j < i; j++) {
          if (ary[j].group.name > ary[j + 1].group.name) {
            tmp = ary[j]
            ary[j] = ary[j + 1]
            ary[j + 1] = tmp
          }
        }
      }
      return ary
    },

    timestamp: function () {
      let date = new Date()
      let timestamp = date.getTime()
      return Math.floor(timestamp / 1000)
    },

    goTo (item) {
      if (item.anim !== 'none') {
        this.$store.commit('routerAnim/set', item.anim)
        this.$router.push({name: item.link})
        // router.push({ name: url, params: { userId: 123 }})
        // window.open(url, '_blank')
      }
    },
    goToMode (name, mode, type) {
      this.$store.commit('routerAnim/set', 'slide')
      this.$router.push({name: name, params: {mode: mode, serviceType: type}})
    },
    goBack () {
      this.$store.commit('routerAnim/set', 'back')
      this.$router.go(-1)
    },
    goBackPath (path) {
      this.$store.commit('routerAnim/set', 'back')
      this.$router.push({path: path})
    },
    moveTab (tab, anim) {
      this.$store.commit('routerAnim/set', anim)
      this.$router.push({name: tab})
    },
    openExternalLink (url) {
      window.open(url, '_system')
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/common.js